import React from "react";
import { useDroppable } from "@dnd-kit/core";
import type { Chip } from "../types";

export default function DropTargetCard({
    droppableId,
    title,
    subtitle,
    rightBadge,
    chips,
    disabled = false,
    disabledReason,
}: {
    droppableId: string;
    title: string;
    subtitle?: string;
    rightBadge?: string;
    chips?: Chip[];
    disabled?: boolean;
    disabledReason?: string;
}) {
    const { isOver, setNodeRef } = useDroppable({
        id: droppableId,
        disabled,
    });

    const border = disabled
        ? "1px dashed #ddd"
        : isOver
            ? "2px dashed #007bff"
            : "1px dashed #ccc";

    const background = disabled ? "#f8f9fa" : isOver ? "#f4faff" : "#fff";

    return (
        <div
            ref={setNodeRef}
            title={disabled ? disabledReason : undefined}
            style={{
                border,
                background,
                borderRadius: 8,
                padding: 10,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                gap: 10,
                opacity: disabled ? 0.6 : 1,
            }}
        >
            <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 700 }}>{title}</div>

                {subtitle ? (
                    <div style={{ fontSize: 12, color: "#666" }}>{subtitle}</div>
                ) : null}

                {disabledReason ? (
                    <div style={{ fontSize: 12, color: "#dc3545", marginTop: 4 }}>
                        {disabledReason}
                    </div>
                ) : null}

                {chips?.length ? (
                    <div style={{ marginTop: 8, display: "flex", flexWrap: "wrap", gap: 6 }}>
                        {chips.slice(0, 6).map((c, idx) => (
                            <button
                                key={c.id ?? idx}
                                type="button"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    c.onDelete?.(c.id);
                                }}
                                title="Klik for at fjerne"
                                style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 6,
                                    fontSize: 11,
                                    padding: "2px 8px",
                                    borderRadius: 999,
                                    border: "1px solid rgba(0,0,0,0.12)",
                                    background: c.dim ? "#e9ecef" : "#1e1e1e",
                                    color: c.dim ? "#333" : "#fff",
                                    cursor: c.onDelete ? "pointer" : "default",
                                }}
                            >
                                <span style={{ whiteSpace: "nowrap" }}>{c.label}</span>
                                {c.onDelete ? <span style={{ fontWeight: 900 }}>✕</span> : null}
                            </button>
                        ))}
                    </div>
                ) : null}
            </div>

            {rightBadge ? (
                <span
                    style={{
                        fontSize: 12,
                        padding: "2px 8px",
                        borderRadius: 999,
                        background: disabled ? "#6c757d" : "#1e1e1e",
                        color: "#fff",
                        whiteSpace: "nowrap",
                    }}
                >
                    {disabled ? "Kan ikke bruges" : rightBadge}
                </span>
            ) : null}
        </div>
    );
}